<template>
    <div class="form-row">
        <template v-if="!arrivalDate">
            <div
                v-for="(date, index) in checkinDatesComputed"
                :key="'date' + index"
                class="form-group col-sm-6 col-md-4"
            >
                <Datepicker
                    :value="date"
                    @change="updateDate($event, index)"
                    :available-dates="availableDatesComputed"
                    :placeholder="$t(datepickerPlaceholder + index)"
                    :required="index === 0"
                    :aria-label="$t(datepickerPlaceholder + index)"
                    :duration="duration"
                    allow-clear
                />
            </div>
        </template>

        <div v-if="alternativeDatesAreEmpty && numberOfDates > 1" class="col-12 mb-3 text-primary">
            {{ $t('Checkout.delayPayment.alternativeHint') }}
        </div>

        <div class="form-group col-12 mb-3" v-if="additionalInformationVisible">
            <textarea
                :value="additionalInformation"
                maxlength="2000"
                @input="$emit('update:additionalInformation', $event.target.value)"
                rows="4"
                class="form-control input-gray message"
                :placeholder="$t('Checkout.delayPayment.additionalInfo', { max: 2000 })"
                :aria-label="$t('Checkout.delayPayment.additionalInfo', { max: 2000 })"
                v-tooltip="$t('Checkout.delayPayment.additionalInfo.tooltip', { br: '<br />' })"
            >
            </textarea>
        </div>
    </div>
</template>

<script>
import Datepicker from '@/components/Datepicker';

export default {
    name: 'ArrivalDateSelection',
    components: {
        Datepicker
    },
    data() {
        return {
            vacancies: {}
        };
    },
    props: {
        productVariantId: {
            required: true,
            type: [String, Number]
        },
        arrivalDate: {
            type: String
        },
        checkinDates: {
            type: Array
        },
        additionalInformation: {
            type: String
        },
        datepickerPlaceholder: {
            type: String,
            default: 'Generic.placeholder.date_'
        },
        duration: Number,
        additionalInformationVisible: Boolean
    },
    computed: {
        availableDates() {
            return this.vacancies.availableDates || [];
        },
        numberOfDates() {
            return this.basedOnContingents ? 1 : 3;
        },
        basedOnContingents() {
            return this.vacancies.basedOnContingents;
        },
        availableDatesComputed() {
            return this.availableDates.filter(date => !this.checkinDates.includes(date));
        },
        checkinDatesComputed() {
            return Array.from(
                {
                    length:
                        this.basedOnContingents || this.availableDates.length > 0
                            ? Math.min(this.availableDates.length, this.numberOfDates)
                            : this.numberOfDates
                },
                (item, index) => this.checkinDates[index] || ''
            );
        },
        alternativeDatesAreEmpty() {
            return this.checkinDatesComputed.every((d, index) => {
                if (index > 0) {
                    return !d;
                } else {
                    return true;
                }
            });
        }
    },
    methods: {
        updateDate(value, index) {
            const dates = [...this.checkinDates];
            dates[index] = value;
            this.$emit('update:checkinDates', dates);
        }
    },
    async mounted() {
        const productVariantId = this.productVariantId;
        try {
            const { data } = await this.$axios.get('/shop/checkout/vacancies', {
                params: { productVariantId }
            });
            this.vacancies = data;
        } catch (e) {
        } finally {
        }
    }
};
</script>

<style scoped lang="scss"></style>
